<div class="card">
  <div class="card-header">
    <h5 class="mb-0">
      <div class="d-grid">
        <button class="btn text-start" type="button" (click)="toggleHelp()">
          {{helpSection.title}}
        </button>
      </div>
    </h5>
  </div>
  <div #content [class]="this.opened ? '' : 'collapse'">
    <div class="card-body">
      <p [innerHTML]="helpSection.content"></p>
    </div>
  </div>
</div>
